import React, { forwardRef } from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";

/**
 * DKNMultiSelect — Daikin design system multi-value select.
 * Wraps Kendo MultiSelect.
 *
 * Props:
 *   data        Array
 *   value       Array — controlled selected values
 *   onChange    (e) => void
 *   onFilter    (e) => void — for server-side filtering
 *   textField   string (default: "text")
 *   dataItemKey string (default: "value")
 *   label       string
 *   error       string
 *   placeholder string
 *   fullWidth   boolean (default: false)
 *   tags        boolean — show selected as chips (default: true)
 */
const DKNMultiSelect = forwardRef(function DKNMultiSelect(
  {
    data = [],
    value,
    onChange,
    onFilter,
    textField = "text",
    dataItemKey = "value",
    label,
    error,
    placeholder,
    fullWidth = false,
    disabled = false,
    className = "",
    style,
    ...rest
  },
  ref
) {
  return (
    <div
      className={`dkn-input-wrap${fullWidth ? " dkn-input-full" : ""}${error ? " dkn-input-error" : ""} ${className}`}
      style={style}
    >
      {label && <label className="dkn-input-label">{label}</label>}
      <MultiSelect
        ref={ref}
        data={data}
        value={value}
        onChange={onChange}
        onFilterChange={onFilter}
        textField={textField}
        dataItemKey={dataItemKey}
        placeholder={placeholder}
        disabled={disabled}
        filterable={!!onFilter}
        className={`dkn-input${error ? " dkn-input-invalid" : ""}`}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

export default DKNMultiSelect;
